import CryptoJS from 'crypto-js';
const { v4: uuidv4 } = require('uuid');
import { catalog, objectId } from './catalog';
import { decodeBase64, encodeBase64 } from '../common/security';

const JWT_SECRET = encodeBase64('GiftShopReactApp');
export const REFRESH_TOKEN_EXPIRATION = 86400;
export const Tokens = catalog('tokens');

export const signature = (message, password) => {
    return CryptoJS.HmacSHA256(message, password);
};

export const createAccessToken = ({ id, name, email, role }) => {
    const header = { typ: 'JWT', alg: 'HS256' };
    const headerBase64 = encodeBase64(JSON.stringify(header));
    const payloadBase64 = encodeBase64(JSON.stringify({ id, name, email, role }));
    const signatureBase64 = CryptoJS.enc.Base64.stringify(
        signature(`${headerBase64}.${payloadBase64}`, JWT_SECRET)
    );
    return `${headerBase64}.${payloadBase64}.${signatureBase64}`;
};

export const createRefreshToken = ({ id }) => {
    const expiredAt = new Date();
    expiredAt.setSeconds(expiredAt.getSeconds() + REFRESH_TOKEN_EXPIRATION);
    const refreshToken = {
        id: objectId(),
        user: id,
        token: uuidv4(),
        expiryDate: expiredAt.getTime()
    };
    Tokens.add(refreshToken);
    return refreshToken.token;
};

export const verifyJwt = (token) => {
    const values = token.split('.');
    if (values.length !== 3) return false;
    const tokenSignature = values[2];
    const requiredSignature = CryptoJS.enc.Base64.stringify(
        signature(`${values[0]}.${values[1]}`, JWT_SECRET)
    );
    return tokenSignature === requiredSignature;
};

export const getJwtUser = (token) => {
    if (!verifyJwt(token)) return null;
    const values = token.split('.');
    const payload = decodeBase64(values[1]);
    return JSON.parse(payload);
};
